export default "/_next/static/media/enjoei-promobanners-1024x284.9e303f4f69190b370f77bb412b485150.png";